import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaWidget from './TextareaWidget';

class CommentWidget extends Component {
  state = {
    open: false,
    initialValue: '',
  };

  onDialogOpen = () => {
    const { value } = this.props;
    const initialValue = value === undefined ? '' : value;
    this.setState({ open: true, initialValue });
  };

  onDialogClose = (cancel = false) => {
    const { formContext } = this.props;
    if (formContext.formStatus === 'editable' && cancel) {
      this.props.onChange(this.state.initialValue);
    }
    this.setState({ open: false, initialValue: '' });
  };

  onCancel = () => {
    this.onDialogClose(true);
  };

  onSave = () => {
    this.onDialogClose(false);
  };

  render() {
    const { classes, formContext, ...textAreaProps } = this.props;
    return (
      <div>
        <TextareaWidget {...textAreaProps} />
      </div>
    );
  }
}

CommentWidget.propTypes = {
  classes: PropTypes.object,
  formContext: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default CommentWidget;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/readonly/CommentWidget.js